import React from 'react';
import {
	SpaceBetween,
} from '@amzn/awsui-components-console';

import { SnowAttribute } from '@amzn/snow-nxt-workflow-service-typescript-client';
import SNOWFormAttribute from 'src/components/commonComponents/SNOWFormAttribute/SNOWFormAttribute';

export interface SNOWFormProps {
	formAttributes: SnowAttribute[];
	title?: string;
}
export default function SNOWForm({ formAttributes }: SNOWFormProps) {
	return (
		<SpaceBetween size="l">
			{formAttributes?.map(
				({
					attributeId,
					attributeName,
					value,
					description,
					dataType,
					regex,
					options,
					helpText,
					mandatory = false,
				}) => {
					const formAttributeId = `${attributeId}`;

					return (
						<SNOWFormAttribute
							attributeId={formAttributeId}
							key={attributeId}
							attributeName={attributeName}
							description={description}
							dataType={dataType}
							placeholder={helpText}
							regex={regex}
							mandatory={mandatory}
							disabled={Boolean(value)}
							options={options}
						/>
					);
				}
			)}
		</SpaceBetween>
	);
}
